import LogService from "../../service/LogService";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { GraphQLClient } from "../../../../../shared/gql-client";

const bulkAPI = new LogService();

export const getAllEntityNames = createAsyncThunk(
  "getAllEntityNames",
  async (_, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };
    bulkAPI.setClient(client);

    try {
      return await bulkAPI.getAllEntityNames();
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const getEntityLog = createAsyncThunk(
  "logs",
  async ({ entity, id }: { entity: string; id: number }, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };
    bulkAPI.setClient(client);

    try {
      return await bulkAPI.getEntityLog(entity, id);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);
